// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3Z9ap","title":"ClientReferral_title__102gd","itemText":"ClientReferral_itemText__3b74c"};